import React from "react";

const CompactAILoader = () => {
  return (
    <div className="inline-flex items-center gap-3 px-4 py-2.5 bg-blue-50 rounded-full border border-blue-100 shadow-sm">
      {/* AI Brain Icon with Pulse */}
      <div className="relative flex items-center justify-center">
        {/* Outer glow */}
        <div className="absolute w-8 h-8 bg-blue-300 rounded-full opacity-20 animate-ping"></div>

        {/* Animated rings */}
        <div className="relative w-6 h-6">
          <div className="absolute inset-0 border-2 border-blue-400 border-t-transparent rounded-full animate-spin"></div>
          <div
            className="absolute inset-0.5 border-2 border-blue-300 border-b-transparent rounded-full animate-spin"
            style={{ animationDuration: "1.5s", animationDirection: "reverse" }}
          ></div>

          {/* Center dot */}
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-2 h-2 bg-blue-500 rounded-full animate-pulse"></div>
          </div>
        </div>
      </div>

      {/* Text with animated dots */}
      <div className="flex items-center gap-1">
        <span className="text-sm font-medium text-blue-700">AI Processing</span>
        <div className="flex gap-0.5">
          <span
            className="w-1 h-1 bg-blue-500 rounded-full animate-bounce"
            style={{ animationDelay: "0ms" }}
          ></span>
          <span
            className="w-1 h-1 bg-blue-500 rounded-full animate-bounce"
            style={{ animationDelay: "150ms" }}
          ></span>
          <span
            className="w-1 h-1 bg-blue-500 rounded-full animate-bounce"
            style={{ animationDelay: "300ms" }}
          ></span>
        </div>
      </div>
    </div>
  );
};

export default CompactAILoader;
